import { createElement } from 'react';
import { observer, useForm } from '@formily/react';
import { Alert } from 'antd';
import { createVoidSchemaComponent } from '../../shared';
const FormilyVarInjectContainer = observer((props) => {
    const form = useForm();
    if (!form) {
        return createElement(Alert, { message: "formily component can only be used in formily form", type: "error" });
    }
    const scope = {
        $record: props.$record,
        $index: props.$index,
    };
    if (props.__designMode === 'design') {
        return createElement("div", Object.assign({}, props), props.render(scope));
    }
    if (typeof props.render === 'function') {
        return createElement("div", Object.assign({}, props), props.render(scope));
    }
    else {
        return createElement(Alert, { message: "Formily \u53D8\u91CF\u6CE8\u5165\u5BB9\u5668\u53EA\u80FD\u4F7F\u7528\u81EA\u5B9A\u4E49\u6E32\u67D3", type: "warning" });
    }
});
export default createVoidSchemaComponent({
    componentName: 'VarInjectContainer',
    component: FormilyVarInjectContainer,
    transform(schema) {
        if (!schema['x-component-props']) {
            schema['x-component-props'] = {};
        }
        delete schema['x-decorator'];
        schema['x-component-props'].$record = '{{ $record }}';
        schema['x-component-props'].$index = '{{ $index }}';
        return schema;
    },
});
